import { DEMO_ALERTS } from '../lib/demo-data';

export default function Alerts() {
  return (
    <div>
      <h1 className="h3 mb-1">Alertas</h1>
      <p className="text-muted small mb-4">
        Regras clínicas e notificações — dados de demonstração.
      </p>

      <div className="row g-3">
        {DEMO_ALERTS.map((a) => (
          <div key={a.id} className="col-12 col-lg-6">
            <div
              className={`card shadow-sm border-start border-4 ${
                a.severity === 'high' ? 'border-danger' : 'border-warning'
              }`}
            >
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <span className="fw-semibold">{a.patientName}</span>
                  <span className="badge text-bg-light text-muted">{a.when}</span>
                </div>
                <p className="mb-2">{a.message}</p>
                <span
                  className={`badge ${
                    a.severity === 'high' ? 'text-bg-danger' : 'text-bg-warning'
                  }`}
                >
                  {a.severity === 'high' ? 'Urgente' : 'Atenção'}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
